import { APPEND_DATA, RESET_DATA } from "./actionTypes";

export const getData = () => ({
	type: "",
});

export const appendData = (payload) => {
	return {
		type: APPEND_DATA,
		payload: payload,
	};
};

export const resetData = () => {
	return {
		type: RESET_DATA,
	};
};
